import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { TerritoryCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type TerritoryCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  name_esSelectedValue?: { displayId: string; id: string } | null;
  onName_esChange?: (value: string) => void;
  name_es: string;
  name_esError?: string;
  name_enSelectedValue?: { displayId: string; id: string } | null;
  onName_enChange?: (value: string) => void;
  name_en: string;
  name_enError?: string;
  name_ptSelectedValue?: { displayId: string; id: string } | null;
  onName_ptChange?: (value: string) => void;
  name_pt: string;
  name_ptError?: string;
  territoryCreateStore: TerritoryCreateStore;
};

export const TerritoryCreateForm: React.FC<TerritoryCreateFormProps> = observer(
  ({
    onSave = () => {},
    onCancel = () => {},
    saving = false,
    showToolbox = true,
    showSaveFooter,
    name_es = "",
    name_esError,
    onName_esChange = () => {},
    name_en = "",
    name_enError,
    onName_enChange = () => {},
    name_pt = "",
    name_ptError,
    onName_ptChange = () => {},
    territoryCreateStore,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            saveAndCloseLabel={langStore.saveEntity}
            closeLabel={langStore.cancelNewEntity}
            saveForm={() => onSave()}
            saveDisabled={saving}
            closeForm={() => onCancel()}
          />
        )}
        <Box>
          <FormExtras
            entity="Territory"
            mode="create"
            values={{}}
            options={{}}
            onPatch={(campo: string, valor: any) => {
              switch (campo) {
                case "name_es":
                  onName_esChange?.(valor);
                  break;
                case "name_en":
                  onName_enChange?.(valor);
                  break;
                case "name_pt":
                  onName_ptChange?.(valor);
                  break;
              }
            }}
          />
          <GroupContainer
            id="null"
            errorText={territoryCreateStore.getCardErrors("null")}
            title={langStore.groupTerritoryLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <InputString
                autoFocus
                value={name_es}
                error={Boolean(name_esError)}
                warning={
                  !name_esError &&
                  Boolean(territoryCreateStore.warnings["name_es"])
                }
                helperText={
                  name_esError ||
                  territoryCreateStore.warnings["name_es"]?.message
                }
                label={langStore.TerritoryNameLabel + " (es)"}
                onChange={(value: string) => onName_esChange(value)}
                description={langStore.TerritoryNameDescription}
              />

              <InputString
                value={name_en}
                error={Boolean(name_enError)}
                warning={
                  !name_enError &&
                  Boolean(territoryCreateStore.warnings["name_en"])
                }
                helperText={
                  name_enError ||
                  territoryCreateStore.warnings["name_en"]?.message
                }
                label={langStore.TerritoryNameLabel + " (en)"}
                onChange={(value: string) => onName_enChange(value)}
                description={langStore.TerritoryNameDescription}
              />

              <InputString
                value={name_pt}
                error={Boolean(name_ptError)}
                warning={
                  !name_ptError &&
                  Boolean(territoryCreateStore.warnings["name_pt"])
                }
                helperText={
                  name_ptError ||
                  territoryCreateStore.warnings["name_pt"]?.message
                }
                label={langStore.TerritoryNameLabel + " (pt)"}
                onChange={(value: string) => onName_ptChange(value)}
                description={langStore.TerritoryNameDescription}
              />
            </FormControl>
          </GroupContainer>
        </Box>
        {(showSaveFooter ?? !showToolbox) && (
          <FormSaveFooter
            onSave={() => onSave()}
            label={langStore.saveEntity}
            disabled={saving}
          />
        )}
      </Grid>
    );
  }
);
